export const Header = () => {
  return (
    <>
      <h1>asciiPicture</h1>
      <p>Convert images to text</p>
    </>
  );
};
